<template>
  <div class="page-view brand-goods" v-show="brandsData">
    <!-- <app-header :path="pagePath"></app-header> -->
    <div class="brands">
      <div class="fx">
        <div class="item" v-for="(item, index) in brandsData" :key="item.optionValue" v-show="item.listUrlImage"
          @click="brandTap(index, item.listId, item.listType)">
          <img class="logo" :src="item.listUrlImage" alt="">
          <p class="brand-name tit-gray" :class="currentBrand === item.listId ? 'active' : ''">{{item.listName}}</p>
        </div>
      </div>
    </div>
    <div class="vouchers">
      <div v-if="pageData.goodsList && pageData.goodsList.length > 0">
        <div class="item" @click="toDetail(item.goodsId)" v-for="item in pageData.goodsList" :key="item.goodsId">
          <van-image
            :src="item.goodsUrlIco"
            width="100%"
          />
          <p class="voucher-name">
            {{item.goodsName}}
          </p>
          <p class="price-box">
            <span>{{item.currency | unitFormat}}{{item.priceReal}} </span>
            <span class="line-through gray" v-if="item.priceReal != item.priceSale">{{item.currency | unitFormat}}{{item.priceSale}}</span>
          </p>
        </div>
      </div>
      <div v-else class="nothing text-center gray">
        Sold Out.  Replenishing...
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading: true,
      pagePath: '',
      currentBrand: null,
      pageData: {},
      advertListParams: {
        token: '',
        listId: '',
        listType: ''
      },
      pageContentParams: {
        pageName: '',
        token: ''
      },
      brandsData: []
    }
  },
  created () {
    this.pagePath = this.$route.fullPath
    const queryParams = this.$route.query
    const token = this.$util.storageGet('local', 'token') || ''
    this.pageContentParams.pageName = 'HOME_' + this.$util.storageGet('local', 'marketCode')
    this.advertListParams.token = token
    this.advertListParams.listId = queryParams.id
    this.advertListParams.listType = queryParams.type
    this.currentBrand = Number(queryParams.id)
    this.loadData()
  },
  methods: {
    // 获取首页展示数据
    getPageContent (params) {
      return this.$http.post('/olvp/getPageContent', 'getPageContent', params, false, false)
    },
    // 查询品牌下商品
    getAdvertListData (params) {
      return this.$http.post('/olvp/getAdvertListData', 'getAdvertListData', params, false, false)
    },
    loadData () {
      this.getPageContent(this.pageContentParams).then((d) => {
        if (d.success) {
          this.brandsData = d.content.advertSpaceDtoList[1].advertList
        }
      })
      this.getGoods()
    },
    getGoods () {
      this.getAdvertListData(this.advertListParams).then((d) => {
        if (d.success) {
          this.pageData = d.content
          if (this.pageData.goodsList) {
            this.pageData.goodsList.map((v) => {
              v.goodsUrlImage = JSON.parse(v.goodsUrlImage)
            })
            this.loading = false
          }
        }
      })
    },
    toDetail (id) {
      this.$router.push(`/productDetail?goodsId=${id}`)
    },
    brandTap (i, id, type) {
      this.currentBrand = id
      this.advertListParams.listId = id
      this.advertListParams.listType = type
      this.getGoods()
    }
  }
}
</script>

<style lang="scss">
  .brand-goods {
    padding: 15px;
    .brands {
      overflow-x: scroll;

      .title {
        color: #388BFF
      }
      .item {
        padding: 8px;
        width: 80px;
        .logo {
          width: 50px;
          height: 50px;
          margin: 0 auto;
          border-radius: 50%;
          border: 1px solid #f4f4f4;
        }

        .brand-name {
          font-size: 12px;
          margin-top: 4px;
          text-align: center;
          overflow:hidden;
          text-overflow:ellipsis;
          white-space:nowrap;
        }

        .active {
          color: #388BFF;
          font-weight: bold;
        }
      }
    }

    .vouchers {
      padding: 15px 0 60px 0;

      .item {
        margin-bottom: 16px;
        img {
          box-shadow: 0 2px 8px #ccc;
          border-radius: 5px;
        }

        .voucher-name {
          font-size: 17px;
          margin-top: 8px;
        }
      }

      .nothing {
        padding: 100px 20px 20px 20px;
        font-size: 15px;
        font-weight: 500;
      }
    }
  }
</style>
